export default __webpack_public_path__ + "static/media/diagonalup_darktolight.a20aeda3.png";